import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from "../../services/functions.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewAlertHistoryComponent } from './view-alert-history/view-alert-history.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from "ngx-spinner";
import { PaginationModel } from 'src/app/models/paginationModel';
import { ExportAlertHistoryComponent } from './export-alert-history/export-alert-history.component';
import { DateAdapter } from '@angular/material/core';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-alert-history',
    templateUrl: './alert-history.component.html',
    styleUrls: ['./alert-history.component.css'],
    providers: [NgxSpinnerService]
})
export class AlertHistoryComponent implements OnInit {
    displayedColumns: string[] = ['id','alertTypeName', 'profileFirstName', 'closedFirstName', 'createdDate', 'closedDate', 'canceled', 'late', 'falseAlert', 'actions'];
    dataSource = new MatTableDataSource<any>();
    alertDate: any;
    filter = "";
    filterDateRange = "";
    filterApplied = false;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    yearList = [];
    public min: Date = new Date("01/01/2019");
    public max: Date = new Date("12/31/" + ((new Date()).getFullYear()).toString());
    currentDate = new Date();
    lastWeek: any;
    startDate: any;
    endDate: any;
    active = "ClosedDate";
    direction = "DESC";
    pageIndex = 0;
    pageSize = 5;
    totalLength = 0;
    falseRealAlert = 5;
    atFilter = "-";
    gFilter = "-";
    scrHeight:any;
    scrWidth:any;
    groupDisabled: boolean;
    alertTypeDisabled: boolean;
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    dateRangeForm = this.formBuilder.group({
        picker: this.formBuilder.group({
          startDate: '',
          endDate: ''
        })
    });

    constructor(
        private apiService: ApiService,
        public functionsService: FunctionsService,
        private modalService: NgbModal,
        private translate: TranslateService,
        private spinner: NgxSpinnerService,
        private formBuilder: UntypedFormBuilder,
        private dateAdapter: DateAdapter<Date>,
        private pagination: PaginationModel) {
        this.alertDate = functionsService;
        this.getScreenSize();
    }

    ngOnInit(): void {
        this.pagination.TimeZone = (-1)*(new Date().getTimezoneOffset()/60);
        this.functionsService.setTitle('alert.alert_history');
        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguageRed(localStorage.getItem('language'));
        }
        //Date range translations
        this.dateAdapter.setLocale(this.language); 
        this.translate.onLangChange.subscribe((event) => {
            this.language = event.lang;
            this.dateAdapter.setLocale(this.language);
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page"); 
            }
        });
        this.yearList = [(new Date()).getFullYear().toString(), ((new Date()).getFullYear() - 1).toString(), ((new Date()).getFullYear() - 2).toString(), ((new Date()).getFullYear() - 3).toString(), ((new Date()).getFullYear() - 4).toString()];
        this.currentDate = new Date();
        this.dataSource.sort = this.sort;
        var sd = new Date(this.min);
        var ed = new Date(this.currentDate);
        ed.setDate(ed.getDate() + 1)
        this.startDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
        this.endDate = (ed.getMonth()+1)+"-"+ed.getDate()+"-"+ed.getFullYear();
        this.fetchGroups();
        this.fetchAlertTypes();
        this.fetchAlerts();
    }
    
    private fetchAlerts() {
        if(!this.filterApplied){
            this.clearFilter();
        }
        this.spinner.show();
        this.pagination.Page = this.pageIndex;
        this.pagination.PageSize = this.pageSize;
        this.pagination.OrderBy = this.active;
        this.pagination.Order = this.direction;
        this.pagination.AlertType = this.atFilter;
        this.pagination.GroupName = this.gFilter;
        this.pagination.FalseAlert = this.falseRealAlert;
        this.pagination.StartDate = this.startDate;
        this.pagination.EndDate = this.endDate;
        this.pagination.Filter = this.filter;
        this.pagination.Late = this.lateFilter;
        this.apiService.getAlertsPaginated(this.pagination).subscribe(resp => {
            this.dataSource.data = Object.values(resp)[0];
            this.totalLength = parseInt(Object.keys(resp)[0]);
            const paginatorLabel = document.getElementsByClassName("mat-paginator-page-size-label")[0];
            if (paginatorLabel) {
                paginatorLabel.innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.spinner.hide();
        }, err => {
            this.functionsService.errorHandler(err["status"]);
            this.spinner.hide();
        });
    }

    public exportAlertHistory() {
        const modalRef = this.modalService.open(ExportAlertHistoryComponent, { size: 'lg' });
        modalRef.componentInstance.ngOnInit();
    }

    public viewAlertDetails(alert) {
        const modalRef = this.modalService.open(ViewAlertHistoryComponent, { size: 'xl'});
        modalRef.componentInstance.viewAlert(alert);
    }

    realFalseObject = {"not_canceled_alerts":4, "out_of_zone_alerts":3, "canceled_alerts":2, "false_alerts":1, "real_alerts":0};
    realFalseAlerts: string[] = Object.keys(this.realFalseObject);
    realFalseFilter: string = "select_status";
    changeRealFalseFilterLabel(typeOfAlert: string) {
        this.realFalseFilter = typeOfAlert;
        this.falseRealAlert = this.realFalseObject[typeOfAlert];
    }

    lateFilter: string = "alert.select-late";
    changeLateFilterLabel(input: string) {
        this.lateFilter = input;
        this.pagination.Late = input;
    }

    fetchAlertTypes() {
        this.apiService.getOpenClosedAlertTypes(1).subscribe(resp => {
            this.alertTypes = resp;
            this.alertTypes.length > 0 ? this.alertTypeDisabled = false: this.alertTypeDisabled = true; 
        }, err => {
            console.error(err);
            this.spinner.hide();
        });
    }

    alertTypes: any = null;
    alertTypeFilter: string = "select_alert_type";
    changeAlertFilterLabel(typeOfAlert: string) {
        this.atFilter = typeOfAlert;
        this.alertTypeFilter = typeOfAlert;
    }

    fetchGroups() {
        this.spinner.show();
        this.apiService.getClosedAlertGroups().subscribe(resp => {
            this.group = resp;
            this.group.length > 0 ? this.groupDisabled = false: this.groupDisabled = true; 
        }, err => {
            console.error(err);
            this.spinner.hide();
        });
    }

    group: any = null;
    groupFilter: string = "select_group";
    changeGroupFilterLabel(typeOfGroup: string) {
        this.gFilter = typeOfGroup;
        this.groupFilter = typeOfGroup;
    }

    nextPage(evt){
        this.pageIndex = evt.pageIndex;
        this.pageSize = evt.pageSize;
        this.fetchAlerts();
    }

    sortData(evt){
        this.active = evt.active;
        this.direction = evt.direction;
        this.fetchAlerts();
    }

    applyFilter() {
        var sd = new Date(this.min);
        var ed = new Date(this.currentDate);
        this.startDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
        this.endDate = (ed.getMonth()+1)+"-"+ed.getDate()+"-"+ed.getFullYear();
    
        if(this.dateRangeForm && this.dateRangeForm.value.picker.startDate){
            sd = new Date(this.dateRangeForm.value.picker.startDate);
            ed = new Date(this.dateRangeForm.value.picker.endDate);
            this.startDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
            this.endDate = (ed.getMonth()+1)+"-"+ed.getDate()+"-"+ed.getFullYear();
        }
        
        if((<HTMLInputElement>document.getElementById('filter')).value !=""){
            this.filter = (<HTMLInputElement>document.getElementById('filter')).value;
            this.filter = this.filter.trim().toLowerCase();
        }
        this.pageIndex = 0;
        this.filterApplied = true;
        this.fetchAlerts();
    }

    clearFilter(){
        this.filter = "";
        this.alertTypeFilter = "select_alert_type";
        this.groupFilter = "select_group";
        this.atFilter = "-";
        this.gFilter = "-";
        this.falseRealAlert = 5;
        this.realFalseFilter = "select_status";
        this.lateFilter = "alert.select-late";
        var sd = new Date(this.min);
        var ed = new Date(this.currentDate);
        this.dateRangeForm.reset();
        this.startDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
        this.endDate = (ed.getMonth()+1)+"-"+ed.getDate()+"-"+ed.getFullYear();
        if((<HTMLInputElement>document.getElementById('daterangepicker_input'))){
            (<HTMLInputElement>document.getElementById('daterangepicker_input')).value = "";
        }
        if((<HTMLInputElement>document.getElementById('filter'))){
            (<HTMLInputElement>document.getElementById('filter')).value = "";
        }
        
        if(this.filterApplied){
            this.filterApplied = false;
            this.fetchAlerts();
        }
    }


    @HostListener('window:resize', [])
    getScreenSize() {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
        this.displayedColumns = ['id', 'alertTypeName', 'profileFirstName', 'closedFirstName', 'createdDate', 'closedDate', 'canceled', 'late', 'falseAlert', 'actions'];
        if(this.scrWidth <= 375){
            this.displayedColumns = ['id', 'alertTypeName', 'closedDate', 'actions'];
        }
        else if(this.scrWidth <= 440){
            this.displayedColumns = ['id', 'alertTypeName', 'closedFirstName', 'closedDate', 'actions'];
        }
        else if(this.scrWidth <= 600){
            this.displayedColumns = ['id', 'alertTypeName', 'closedFirstName', 'closedDate', 'actions'];
        }
    }
}
